import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivateCoverage = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "activateCoverage",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12841",
			"data-name": "Path 12841",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12842",
			"data-name": "Path 12842",
			d: "M7,7h5.5",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12843",
			"data-name": "Path 12843",
			d: "M7,11h3",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12844",
			"data-name": "Path 12844",
			d: "M10,21H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H17a2,2,0,0,1,2,2V9",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12845",
			"data-name": "Path 12845",
			d: "M12,14.031,16,12l4,2.031V17a4,4,0,0,1-8,0Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgActivateCoverage;
